//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TotalProfit from './cards/TotalProfit.vue'
import TotalVisitors from './cards/TotalVisitors.vue'
import WeeklySales from './cards/WeeklySales.vue'
import TotalRevenue from './cards/TotalRevenue.vue'
import WeeklyOverview from './cards/WeeklyOverview.vue'
import Performance from './cards/Performance.vue'
import Analytics from './cards/Analytics.vue'
import SalesState from './cards/SalesState.vue'
import TotalSales from './cards/TotalSales.vue'
import TotalProfitRadial from './cards/TotalProfitRadial.vue'
import TotalVisits from './cards/TotalVisits.vue'
import RevenueReport from './cards/RevenueReport.vue'
import ActivityTimeline from './cards/ActivityTimeline.vue'
import SalesOverview from './cards/SalesOverview.vue'

export default {
  components: {
    TotalProfit,
    TotalVisitors,
    WeeklySales,
    TotalRevenue,
    WeeklyOverview,
    Performance,
    Analytics,
    SalesState,
    TotalSales,
    TotalProfitRadial,
    TotalVisits,
    RevenueReport,
    ActivityTimeline,
    SalesOverview,
  },
}
